import { flow, types, getEnv, getRoot } from 'mobx-state-tree'

import { Trigger } from './'

const TriggersModel = types
  .model('TriggersModel', {
    items: types.optional(types.map(Trigger), {}),
  })
  .actions((self) => {
    const {
      services: { triggerService },
    } = getEnv(self)

    return {
      add(trigger) {
        if (!trigger) {
          return null
        }

        const root = getRoot(self)
        const event = trigger.eventDTO

        self.items.set(trigger.id, {
          ...trigger,
          event: event.id,
        })

        root.events.add(event)

        return self.items.get(trigger?.id)
      },

      get(id) {
        return self.items.get(id)
      },

      loadForEvent: flow(function* (eventId, params) {
        const response = yield triggerService.queryEventTriggers(
          eventId,
          params
        )
        const triggers = response.content.map((trigger) => self.add(trigger))

        return {
          response,
          triggers,
        }
      }),
    }
  })

export const TriggersRoot = types.model('TriggersRoot', {
  triggers: types.optional(TriggersModel, {}),
})
